import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PAYOR, checkRole, getBrokersList, getDistanceFromLatLon, getTimeAndDistance, timeCalculation } from '../../../utils/utils.common';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';
import * as _ from 'underscore';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { Events } from 'src/app/utils/event-utils';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import { MapsAPILoader } from '@agm/core';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { forkJoin, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { CorporateService } from '../../corporate-user/corporate-service/corporate-service';
import { StaffService } from '../../staffs/staff-service/staff.service';
import { UserRoles } from '../../shared/layout/menu-service/menu.service';
import { CompaniesService } from '../../companies/service/companies.service';
import { AuthService } from 'src/app/service/auth-service/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-operations-v2',
  templateUrl: './operations-v2.component.html',
  styleUrls: ['./operations-v2.component.css']
})
export class OperationsV2Component implements OnInit, AfterViewInit, OnDestroy {
  payorList = PAYOR;
  duration = 10 * 1000; // 10 seconds
  tripAssistanceTimer;
  user;
  search = '';
  selectedCorporate = [];
  brokers = getBrokersList;
  currentTime;
  trips = [];
  proposedTrips = [];
  markedReadyTrips = [];
  alarmingTrips = [];
  inprogressTrips = [];
  scheduledTrips = [];
  cancelledTrips = [];
  finishedTrips = [];
  settingInterval;

  componentType;
  notesModalObj;
  assignTripModalObj;
  tripDetailModalObj;
  live;
  counter: number = 10;
  tripAssistanceList;
  selectedTripSection;
  selectedTripId;

  @ViewChild('timer', { static: true }) timer;
  view = 'grid';
  directionMatrixService;
  // timeZone;
  isGoogleApprox = false;
  showSlideFilter = false;
  isLocalApprox = false;
  subscription: Subscription;
  subMenu = 'v2';
  preCooperates = {};
  preLevelOfServices = {};
  preSpaceTypes = {};
  selectedServiceArea = [];
  preServiceAreas = {};
  corporateList = [];
  filteredCorporates = [];
  serviceAreaList = [];
  filteredServiceAreas = [];

  stationManagerList = [];
  filteredStationManagers = [];
  selectedStationManager = [];
  preStaffList = {};
  isAllowRates = false;
  selectedCompany: any = "";
  selectedCompanyId = "";
  companiesList:any;
  selectedCompanyToken: any;

  timeZone = '';
  clockTime = moment().toISOString();

  timePickerDate = moment();

  preCompanies = {};
  intervalTimeID: any;

  constructor(
    private companyService : CompaniesService,
    private assignTripService: AssigTripsService,
    private socketService: SocketService,
    private mapsAPILoader: MapsAPILoader,
    private sharedDataService: SharedDataService,
    private corporateService: CorporateService,
    private staffService: StaffService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {

    this.intervalTimeID = setInterval(() => {
      this.clockTime = moment().toISOString();
    }, 1000);

    this.getCorporate();
    this.mapsAPILoader.load().then(async () => {
      this.directionMatrixService = new google.maps.DistanceMatrixService()
      this.getUser();
      this.getStaffList();
      this.getCompaniesList();
    });

    this.socketService.addListener(Events.GET_ASSIGN_TRIP_ETA)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          if (data.success && this[this.selectedTripSection] && this[this.selectedTripSection].length) {
            const selectedTrip = this[this.selectedTripSection].find((x) => x._id === this.selectedTripId);
            if (selectedTrip) {
              selectedTrip.loadedMessage = data.message;
            }
            this.selectedTripSection = null;
            this.selectedTripId = null;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  getCompaniesList() {
    const queryParams = {
      accountStatus: 'active',
      isRemoveIAAL: false
    }

    this.companyService.getCompanies(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data) => {
      if (data) {
        this.companiesList = data;
        this.preCompanies = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
      }
    });
  }

  clear() {
    this.markedReadyTrips = [];
    this.alarmingTrips = [];
    this.inprogressTrips = [];
    this.scheduledTrips = [];
    this.cancelledTrips = [];
    this.finishedTrips = [];
  }

  onChangeCompany(event) {
    this.clear();
    if(event){
      this.selectedCompany = event;

      if (this.preCompanies && this.preCompanies[event] && this.preCompanies[event].timeZone) {
        this.timeZone = this.preCompanies[event].timeZone;
      }
      this.timer.start();
      this.getCompanyToken();

    } else {
      this.timeZone = this.user.timeZone;
      this.selectedCompany = '';
    }
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = user.timeZone;
          // this.getAllTrips();
          this.listenSocket();
          const myUser = user.company ? user.company : user;
          if (myUser.isTripAssistance) {
            this.getTripAssistanceList();
            this.getTripAssistance();
          }
          if (this.user.hasOwnProperty('isListView') && this.user.isListView) {
            this.setView('list');
          }
          this.isAllowRates = checkRole(this.user);
        }
      });
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getConfigurations()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1]) => {

        if (res1) {
          this.preLevelOfServices = res1.levelofservices.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.preSpaceTypes = res1.spacetypes.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.preServiceAreas = res1.serviceareas.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getTripAssistanceList() {
    this.assignTripService
      .getTripAssistanceList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripAssistanceList = data;
        }
      })
  }

  processTripAssistace(trip) {
    sweetAlert('Alert', `Are you sure you want to ${trip.isDone ? 'unmarked' : 'mark'} ready?`, 'warning', 'Yes', 'No')
      .then((result) => {
        if (result.value) {
          let payload = trip;

          if (trip.isDone) {
            payload.isDone = false;
          } else {
            payload.isDone = true;
          }
          this.assignTripService
            .processTripAssistance(trip._id, payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                this.tripAssistanceList.array.forEach(item => {
                  if (item._id === data._id) {
                    item = data;
                  }
                });


              }
            })
        }
      });
  }

  // incrementCounter() {
  //   // Increment the counter
  //   this.counter--;
  //    setTimeout(() => {
  //     if(this.counter == 0){
  //       this.getAllTrips();
  //       this.counter = 10;
  //     }
  //     this.incrementCounter();
  //   }, 1000);
  // }

  getAllTrips() {
    if (!this.selectedCompany) {
      return;
    }
    console.log(this.timeZone);
    const params = {
      scheduleTime: moment(this.timePickerDate).tz(this.timeZone, true).toISOString(),
      allowFinished : true
    };

    this.assignTripService
      .getTripsForAssignDashboard(params)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timer.start();
          this.currentTime = data.currentTime;
          this.trips = data.assigns;
          this.filterTrips();
        }
      });
  }

  async filterTrips() {
    this.proposedTrips = [];
    this.markedReadyTrips = [];
    this.alarmingTrips = [];
    this.inprogressTrips = [];
    this.scheduledTrips = [];
    this.cancelledTrips = [];
    this.finishedTrips = [];
    let onBoardingTrips = [];
    let cooperates = [];
    let serviceAreas = [];
    let stationManagers = [];
    this.trips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.trips.forEach((trip) => {
      const time = timeCalculation(trip, this.currentTime);
      trip.time = time;

      if (trip.serviceArea) {
        serviceAreas.push(trip.serviceArea);
      }
      if (trip.driver && trip.driver.stationManager) {
        stationManagers.push(trip.driver.stationManager);
      }

      if (trip.cooperate) {
        cooperates.push(trip.cooperate);
      }
      if (trip.isReadyForPickup) {
        this.markedReadyTrips.push(trip);
      }

      if (trip.isProposedReadyTime) {
        this.proposedTrips.push(trip);
      }

      if (trip.status === 'cancelled') {
        this.cancelledTrips.push(trip);
      } else if (trip.status === 'inprogress') {
        if (this.isGoogleApprox || this.isLocalApprox) {
          this.setApproximateTime(trip);
        } else {
          this.setDefaultApproximation(trip);
        }
        if (trip.job && (trip.job.memberNotVisible || trip.job.isMemberLoading)) {
          onBoardingTrips.push(trip);
        } else {
          this.inprogressTrips.push(trip);
        }
      } else if (trip.status === "finished") {
        this.finishedTrips.push(trip);
        console.log("finishedTrips",this.finishedTrips)

      }
      else if ((time <= 60) || trip.status === 'declined' || trip.status === 'bumped') {
        this.alarmingTrips.push(trip);
      } else if (time > 60) {
        this.scheduledTrips.push(trip);
      }
    });
    serviceAreas = _.uniq(serviceAreas).sort();
    stationManagers = _.uniq(stationManagers).sort();

    cooperates = _.uniq(cooperates).sort();

    if (serviceAreas && serviceAreas.length) {
      this.filteredServiceAreas = this.serviceAreaList.filter(c => serviceAreas.includes(c._id));
    }


    if (stationManagers && stationManagers.length) {
      this.filteredStationManagers = this.stationManagerList.filter(c => stationManagers.includes(c._id));
    }

    if (cooperates && cooperates.length) {
      this.filteredCorporates = this.corporateList.filter(c => cooperates.includes(c._id));
    }

    onBoardingTrips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.inprogressTrips.sort((a, b) => {
      if (a.scheduleTime < b.scheduleTime) return -1;
      if (a.scheduleTime < b.scheduleTime) return 1;
      return 0;
    });
    this.inprogressTrips = [...onBoardingTrips, ...this.inprogressTrips];
    const x = {};
    this.inprogressTrips.forEach(t => {
      x[t.driver._id] = {
        isAlarmingFound: false,
        isScheduledFound: false,
        approxDO: t.approxDO, scheduleTime: t.scheduleTime,
        jobOriginLatitude: t.jobOriginLatitude,
        jobOriginLongitude: t.jobOriginLongitude,
        jobDestinationLatitude: t.jobDestinationLatitude,
        jobDestinationLongitude: t.jobDestinationLongitude
      };
    });
    const drivers = Object.keys(x);
    this.alarmingTrips.forEach(trip => {
      if (
        trip.driver && trip.driver._id &&
        drivers.includes(trip.driver._id) &&
        !x[trip.driver._id].isAlarmingFound &&
        !x[trip.driver._id].isScheduledFound && // un nessecity
        moment(trip.scheduleTime).isAfter(moment(x[trip.driver._id].scheduleTime))
      ) {
        x[trip.driver._id].isAlarmingFound = true;
        this.setNextTripPickupTime(x[trip.driver._id], trip);
      }
    })
    this.scheduledTrips.forEach(trip => {
      if (
        trip.driver && trip.driver._id &&
        drivers.includes(trip.driver._id) &&
        !x[trip.driver._id].isAlarmingFound &&
        !x[trip.driver._id].isScheduledFound &&
        moment(trip.scheduleTime).isAfter(moment(x[trip.driver._id].scheduleTime))
      ) {
        x[trip.driver._id].isScheduledFound = true;
        this.setNextTripPickupTime(x[trip.driver._id], trip);
      }
    })
  }

  async setNextTripPickupTime(inprogressTrip, nextTrip) {
    const distanceAndTime = getTimeAndDistance(
      inprogressTrip.jobDestinationLatitude, inprogressTrip.jobDestinationLongitude,
      nextTrip.jobOriginLatitude, nextTrip.jobOriginLongitude, 50
    );
    let minutesToAdd = 0;
    if (distanceAndTime) {
      minutesToAdd = distanceAndTime.timeInMinutes;
      if (nextTrip.tripRequirement === 'WAV') {
        minutesToAdd += 5;
      } else if (nextTrip.tripRequirement === 'Stretcher') {
        minutesToAdd += 15;
      } else {
        minutesToAdd += 2;
      }
      let approxPU = moment(inprogressTrip.approxDO).tz(this.timeZone).add(minutesToAdd, 'minutes');
      nextTrip.approxPU = approxPU.toISOString();
      nextTrip.puTimeDiff = moment(nextTrip.scheduleTime).tz(this.timeZone).diff(approxPU, 'minutes', true);
      // nextTrip.doTimeDiff = nextTrip.puTimeDiff;
      // for the estimated Do
      let mins = (parseFloat(nextTrip.milage) / 0.621371 / 50) * 60;
      let approxDO = moment(nextTrip.approxPU).tz(this.timeZone).add(mins, 'minutes');
      nextTrip.approxDO = approxDO.toISOString();
      nextTrip.doTimeDiff = moment(nextTrip.appointmentTime).tz(this.timeZone).diff(approxDO, 'minutes', true);
    }

  }

  listenSocket() {
    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          this.trips.filter((trip) => {
            if (data.assign._id === trip._id) {
              trip.isReadyForPickup = data.assign.isReadyForPickup;
              // this.getAllTrips();
            }
          });
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });

    this.socketService.addListener(Events.GET_MILES_CALL)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // this.inprogressTrips.filter((trip) => {
          //   if (data.assign._id === trip._id) {
          //     trip.isReadyForPickup = data.assign.isReadyForPickup;
          //     this.getAllTrips();
          //   }
          // });
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  markReadyTrip(assign) {
    const tempAssign = JSON.parse(JSON.stringify(assign));
    const payload = {
      assignId: tempAssign._id,
      isReadyForPickup: !tempAssign.isReadyForPickup
    }
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, payload);
  }

  getETA(trip, objectName) {
    this.assignTripService
      .getETA(trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (this[objectName] && this[objectName].length) {
          const selectedTrip = this[objectName].find((x) => x._id === data._id);
          if (selectedTrip) {
            selectedTrip.etaMessage = data.etaMessage;
          }
        }
      });
  }

  loadedMiles(trip, objectName) {
    this.selectedTripSection = objectName;
    this.selectedTripId = trip._id;
    const payload = {
      assignId: trip._id,
      isDriveTime: true
    }
    this.socketService.emit(Events.GET_ASSIGN_TRIP_ETA, payload);
  }

  assignTrip(trip) {
    this.assignTripModalObj = trip;
    this.componentType = 'dashboard';
  }

  onAssignTrip(tripStatus: string) {
    this.getAllTrips();
    this.assignTripModalObj = null;
    this.componentType = null;
  }

  viewNotes(trip) {
    this.notesModalObj = trip;
  }

  viewTripDetails(trip) {
    this.tripDetailModalObj = trip;
  }

  getBroker(key) {
    return getBrokersList[key];
  }

  sortMethod(a, b) {
    return new Date(a.key) > new Date(b.key) ? 1 : -1;
  }

  // ngAfterViewInit() {
  // }

  ngAfterViewInit(): void {
    // this.timer.start();
    // this.getAllTrips();
  }

  onTimerComplete(): void {
    this.timer.init()
    this.getAllTrips();

  }

  getTripAssistance() {
    // if (this.tripAssistanceTimer) return;
    if (this.tripAssistanceTimer) {
      clearInterval(this.tripAssistanceTimer);
    }

    this.tripAssistanceTimer = setInterval(() => {
      this.getTripAssistanceList();
    }, 30000)
  }
  formatMyTimer(timer): void {
    if (timer)
      this.timer.formattedTimeLeft = timer.split(':')[1];
    else
      this.timer.formattedTimeLeft = '0'
  }

  async getDistance(origin, destination) {
    let seconds;

    const request: any = {
      origins: [new google.maps.LatLng(origin.lat, origin.lng)],
      destinations: [new google.maps.LatLng(destination.lat, destination.lng)],
      travelMode: google.maps.TravelMode.DRIVING
    }

    if (this.isGoogleApprox) {
      const res = await this.directionMatrixService.getDistanceMatrix(request, (response, status) => {
        if (status === 'OK' && response) {
          if (response.rows && response.rows.length) {
            const elements = response.rows[0].elements;
            if (elements && elements.length && elements[0].status === "OK") {
              const data = elements[0];
              seconds = data.duration.value;
              return seconds;
            }
          }
        }
        return null;
      });
    } else {
      const distance = getDistanceFromLatLon(request.origins[0].lat(), request.origins[0].lng(), request.destinations[0].lat(), request.destinations[0].lng());
      // converting per miles
      if (distance <= 5) {
        seconds = 5 * 60;
      } else {
        seconds = (distance + 5) * 60;
      }
    }

    return seconds;
  }

  async setApproximateTime(trip) {
    if (trip.job && trip.job.trackInfoJob && this.isEventExist(trip.job.trackInfoJob.jobAccepted)) {
      const res1 = await this.getDistance({ lat: trip.job.trackInfoJob.jobAccepted.coords[1], lng: trip.job.trackInfoJob.jobAccepted.coords[0] }, { lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude });
      if (res1) {
        // jobAccepted time
        let approxPU = moment(trip.job.trackInfoJob.jobAccepted.time).tz(this.timeZone).add(res1, 'seconds');
        trip.approxPU = approxPU.toISOString();
        let scheduleTime = moment(trip.scheduleTime).tz(this.timeZone);
        trip.puTimeDiff = scheduleTime.diff(approxPU, 'minutes');
        trip.puTimeMsg = trip.puTimeDiff < 0 ? 'Late' : 'Early';

        if (this.isEventExist(trip.job.trackInfoJob.jobStarted)) {
          const res = await this.getDistance({ lat: trip.job.trackInfoJob.jobStarted.coords[1], lng: trip.job.trackInfoJob.jobStarted.coords[0] }, { lat: trip.jobDestinationLatitude, lng: trip.jobDestinationLongitude });
          if (res) {
            let approxDO = moment(trip.job.trackInfoJob.jobStarted.time).tz(this.timeZone).add(res, 'seconds');
            trip.approxDO = approxDO.toISOString();
            let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
            trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes', true);
            trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
          }
        } else {
          const res = await this.getDistance({ lat: trip.jobOriginLatitude, lng: trip.jobOriginLongitude }, { lat: trip.jobDestinationLatitude, lng: trip.jobDestinationLongitude });
          if (res) {
            let approxDO = moment(trip.approxPU).tz(this.timeZone).add(res, 'seconds');
            trip.approxDO = approxDO.toISOString();
            let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
            trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes', true);
            trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
          }
        }
      }
    }
  }

  setDefaultApproximation(trip) {
    if (trip.job && trip.job.trackInfoJob) {
      if (this.isEventExist(trip.job.trackInfoJob.jobAccepted) && trip.job.trackInfoJob.jobAccepted.aproxTime) {
        // let approxPU = moment(trip.job.trackInfoJob.jobAccepted.aproxTime).tz(this.timeZone)
        // trip.approxPU = approxPU.toISOString();
        // let scheduleTime = moment(trip.scheduleTime).tz(this.timeZone);
        // trip.puTimeDiff = scheduleTime.diff(approxPU, 'minutes');
        // trip.puTimeMsg = trip.puTimeDiff < 0 ? 'Late' : 'Early';
        trip.approxPU = trip.job.trackInfoJob.jobAccepted.aproxTime;
        trip.puTimeDiff = moment(trip.scheduleTime).diff(moment(trip.approxPU), 'minutes', true);
      }
      if (this.isEventExist(trip.job.trackInfoJob.jobAproxDo) && trip.job.trackInfoJob.jobAproxDo.aproxTime) {
        // let approxDO = moment(trip.job.trackInfoJob.jobAproxDo.aproxTime).tz(this.timeZone);
        // trip.approxDO = approxDO.toISOString();
        // let appointmentTime = moment(trip.appointmentTime).tz(this.timeZone);
        // trip.doTimeDiff = appointmentTime.diff(approxDO, 'minutes');
        // trip.doTimeMsg = trip.doTimeDiff < 0 ? 'Late' : 'Early';
        trip.approxDO = trip.job.trackInfoJob.jobAproxDo.aproxTime;
        trip.doTimeDiff = moment(trip.appointmentTime).diff(moment(trip.approxDO), 'minutes', true);
      }

    }
  }

  isEventExist(event) {
    return event && event.coords.length === 2 && event.coords[0] && event.coords[1];
  }

  setView(type) {
    this.view = type;
    if (this.view === 'list') { // for reset timer and refetch data
      this.timer.init();
      this.timer.start();
      this.getAllTrips();
    }
  }

  toggleApprox(method) {
    if (method === 'google') {
      this.isGoogleApprox = !this.isGoogleApprox;
      if (this.isGoogleApprox) {
        this.isLocalApprox = false;
      }
    } else if (method === 'local') {
      this.isLocalApprox = !this.isLocalApprox;
      if (this.isLocalApprox) {
        this.isGoogleApprox = false;
      }
    }
  }

  showFilter() {
    this.showSlideFilter = !this.showSlideFilter
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  shortStatus(status, jobStatus) {
    let str = '';
    if (status === 'unassigned') {
      str = 'UN';
    } else if (status === 'offered' || status === 'offered') {
      str = 'AS';
    } else if (status === 'inprogress') {
      if (jobStatus === 'onway') {
        str = 'OW'
      } else if (jobStatus === 'arrived') {
        str = 'AR'
      } else if (jobStatus === 'started') {
        str = 'MO'
      } else if (jobStatus === 'completed') {
        str = 'CP'
      }
    } else if (status === 'finished') {
      str = 'FN';
    } else if (status === 'cancelled') {
      str = 'CN'
    }

    return str;
  }

  getTripsCount() {
    let count = 0;
    if (this.alarmingTrips && this.alarmingTrips.length) {
      count = count + this.alarmingTrips.length;
    }

    if (this.inprogressTrips && this.inprogressTrips.length) {
      count = count + this.inprogressTrips.length;
    }

    if (this.scheduledTrips && this.scheduledTrips.length) {
      count = count + this.scheduledTrips.length;
    }

    if (this.cancelledTrips && this.cancelledTrips.length) {
      count = count + this.cancelledTrips.length;
    }
    if (this.finishedTrips && this.finishedTrips.length) {
      count = count + this.finishedTrips.length;
    }

    return count;
  }

  convert(num) {
    // return Math.abs(num);
    return this.viewHourFormat(Math.abs(num) * 60000);
  }

  viewHourFormat(milli) {
    let duration = moment.duration(milli, 'milliseconds');
    return `${Math.floor(duration.asHours())}hr ${duration.minutes()}mins`;
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id; // index or item.id
  }

  getCorporate() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.corporateList = data;
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getConfigurations() {
    return this.assignTripService.getConfigurations();
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.stationManagerList = data;
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getCompanyToken(): any {
    if (!this.selectedCompany) {
      return;
    }
    this.companyService.getCompanyToken(this.selectedCompany)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data: any) => {
      if(data){
        this.authService.setToken(data.companyToken,'providerToken');
        this.makeCompulsoryCalls();
        this.getAllTrips();
      }
    })
  }

  onChangeDate(event) {
    this.timePickerDate = event;
    this.onChangeCompany(this.selectedCompany);
  }

  openNewTrip() {
    const data = {
      companyToken:localStorage.getItem('token'),
      companyId: this.selectedCompany
    }
    this.router.navigateByUrl('/trips/new', { state: data });
  }


  ngOnDestroy() {
    if (this.tripAssistanceTimer) {
      clearInterval(this.tripAssistanceTimer);
    }

    if (this.intervalTimeID) {
      clearInterval(this.intervalTimeID);
    }

    this.socketService.removeListener(Events.UPDATE_ASSIGN_TRIP);
    this.socketService.removeListener(Events.GET_ASSIGN_TRIP_ETA);
    localStorage.removeItem('providerToken');

  }
}

